/*
 * @Author: jiangxd
 * @Date: 2021-08-04 11:24:02
 * @LastEditTime: 2021-08-04 11:44:22
 * @LastEditors: jiangxd
 * @Description:
 * @FilePath: /rs_ips_maintence/src/views/components/shopDisplaySketchMap/displayEdit/propagate.tsx
 */
import { Vue, Component, Prop, Watch, Inject } from "vue-property-decorator";
import AdContent from "./adContent";
import style from "./style.vue";
import { numberToArray } from "@/util";

export const lunbo = "https://ssl-picture.tenyun.runsasoft.com/lunbotu.jpg";
export const yihangyitu = "https://ssl-picture.tenyun.runsasoft.com/yihangyitu.jpg";
export const hengxianggundong = "https://ssl-picture.tenyun.runsasoft.com/hengxiangdatu.jpg";

@Component({
	components: {},
	mixins: [style],
})
export default class Propagate extends Vue {
	@Prop({ default: () => {} })
	value: DisplayPropagateData;

	@Prop({ default: false })
	disabled: boolean;

	@Prop({ default: false })
	saveLayout: boolean;

	@Inject({ default: 1 })
	mode: number;

	// 1 镜千-店铺 2 镜千-个人中心 3 镜千-微页面 4 镜千/云单-商详 5 镜千-hot 6 云单-商城页 7 云单-个人中心 8 云单(网点)-微页面 9 云单(网点组)-微页面 10 云单 hot
	@Prop()
	fromPage: number;

	@Prop({ default: () => [] })
	attrButeList: ItemArray;

	data: DisplayPropagateData = {};

	@Watch("value", { deep: true, immediate: true })
	watchValue(n, o) {
		if (JSON.stringify(n) !== JSON.stringify(o)) {
			this.data = n;
		}
	}

	@Watch("data", { deep: true })
	watchData() {
		this.$emit("input", this.data);
	}

	render(h) {
		return (
			<div class="propagate-edit" key={this.data.sort}>
				{this.fromPage !== 6 && this.fromPage !== 7 && this.fromPage !== 8 && <p class="title">基本属性</p>}
				<el-form label-width="120px" props={{ model: this.data }} ref="form" disabled={this.disabled} show-message={false}>
					{this.fromPage !== 6 &&
						this.fromPage !== 7 &&
						this.fromPage !== 8 && [
							<el-form-item label="广告位名称" prop={"desc.pName"} rules={{ required: true, trigger: "blur" }}>
								<el-input maxlength="20" v-model={this.data.desc.pName} placeholder="请输入广告位名称"></el-input>
							</el-form-item>,
							<el-form-item label="建议广告位尺寸" prop={"desc.pHeight"} rules={{ required: true, trigger: "blur" }} class="propagate-size">
								<el-input disabled v-model={this.data.desc.pWidth} class="wid-40"></el-input> px * <el-input-number controls={false} min={1} v-model={this.data.desc.pHeight} class="wid-40"></el-input-number> px
							</el-form-item>,
							<el-form-item label="广告最大页数" prop={"desc.pMaxPage"}>
								<el-select v-model={this.data.desc.pMaxPage} class="wid-50">
									{numberToArray(10).map((i) => {
										return (
											<el-option label={i} value={i}>
												{i}
											</el-option>
										);
									})}
								</el-select>{" "}
								页
							</el-form-item>,
						]}
					<p class="title">展示方式</p>
					<el-radio-group v-model={this.data.desc.pStyle} class="propagate-show-type">
						<el-row class="margin-top-none">
							<el-col span={8}>
								<el-radio label={1}>轮播图</el-radio>
								<img src={lunbo} class="show-type" />
							</el-col>
							<el-col span={9}>
								<el-radio label={2}>横向大图滚动</el-radio>
								<img src={hengxianggundong} class="show-type" />
							</el-col>
							<el-col span={7}>
								<el-radio label={3}>一行一图</el-radio>
								<img src={yihangyitu} class="show-type" />
							</el-col>
						</el-row>
					</el-radio-group>
					<p class="title">图文样式</p>
					<el-row class="propagate-style">
						<el-col span={8}>标题显示</el-col>
						<el-col span={16}>
							<el-radio-group v-model={this.data.desc.displayType}>
								<el-radio label={1} class="show-inner">
									图片内部显示
								</el-radio>
								<el-radio label={2} class="show-out">
									图片外部显示
								</el-radio>
								<el-radio label={3}>不显示标题</el-radio>
							</el-radio-group>
						</el-col>
					</el-row>
					<el-row>
						<el-col span={8}>图片边距</el-col>
						<el-col span={16}>
							<el-slider step={2} v-model={this.data.desc.margin} min={0} max={40} style="width: 92%"></el-slider>
						</el-col>
						<el-col span={4}>
							{/* <el-input-number
              step-strictly={true}
              controls={false}
              min={0}
              max={40}
              value={value.desc.margin}
              onInput={(val) => this.onInputPadding(val, value)}
              style="width:50px"></el-input-number> */}
						</el-col>
					</el-row>
					<el-row>
						<el-col span={8}>图片圆角</el-col>
						<el-col span={16}>
							<el-slider step={2} v-model={this.data.desc.borderRadius} min={0} max={40} style="width: 92%"></el-slider>
						</el-col>
						<el-col span={4}>
							{/* <el-input-number
              step-strictly={true}
              controls={false}
              min={0}
              max={40}
              value={value.desc.borderRadius}
              onInput={(val) => this.onInputBorderRadius(val, value)}
              style="width:50px"></el-input-number> */}
						</el-col>
					</el-row>
					{(this.fromPage === 6 || this.fromPage === 7 || this.fromPage === 8) && <p class="title r-mb-0">图文内容(拖动可排序)</p>}
					{(this.fromPage === 6 || this.fromPage === 7 || this.fromPage === 8) && <p class="tip blockTip r-mb-8">请保持图片的分辨率一致，建议为750*600，大小不超过1M。</p>}
					{(this.fromPage === 6 || this.fromPage === 7 || this.fromPage === 8) && <AdContent v-model={this.data.desc.list} fromPage={this.fromPage} attrButeList={this.attrButeList} />}
				</el-form>
				{/* <el-row>
        <el-col span={8} class="config-title">
          区域底色
        </el-col>
        <el-col span={6}>
          <el-color-picker v-model={value.desc.backGround}></el-color-picker>
        </el-col>
        <el-col span={10}>{value.desc.backGround}</el-col>
      </el-row> */}
			</div>
		);
	}
}
